export default __webpack_public_path__ + "static/media/call-a-person-contact-img.02184f1c.svg";